import { baseUrlFeedback } from '@/constants'
import {
  AddInstitutionalAssessmentResponseClassroomSubjectPayload,
  AddInstitutionalAssessmentResponseParams,
  AddInstitutionalAssessmentResponsePayload,
  FeedbackRequiredFieldParams,
  InstitutionalAssessment,
  InstitutionalAssessmentDetails,
  RateablePayload,
  Res,
} from '@/types'
import { removeNullProps } from '@/utils'

import base from './base'

// const baseQuery = fetchBaseQuery({
//   baseUrl: baseUrlFeedback,
//   prepareHeaders: (headers, { getState }) => {
//     const fromState = (getState() as RootState).account.token
//     const fromStorage = getToken()
//     const token = fromState || fromStorage
//     if (token) {
//       headers.set('authorization', `Bearer ${token}`)
//     }
//     return headers
//   },
// })

// const baseQueryFeedbackFn: BaseQueryFn<
//   string | FetchArgs,
//   unknown,
//   FetchBaseQueryError
// > = async (args, api, extraOptions) => {
//   let result = await baseQuery(args, api, extraOptions)
//   if (result.error && shouldRefresh(result.error)) {
//     const res = await baseQuery({ url: '/refresh', method: 'POST' }, api, extraOptions)
//     if (!res.data) {
//       api.dispatch(logout())
//     }
//     const { token } = res.data as { token: string | null }
//     if (token) {
//       api.dispatch(saveToken(token))
//       result = await baseQuery(args, api, extraOptions)
//     } else {
//       api.dispatch(logout())
//     }
//   }
//   return result
// }

// export const tagTypes = ['Feedbacks'] as const

const baseFeedbackApi = base.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    giveFeedback: builder.mutation<void, RateablePayload>({
      query: (body) => ({
        url: `${baseUrlFeedback}/feedbacks`,
        method: 'POST',
        body: body instanceof FormData ? body : removeNullProps({ ...body }),
      }),
      invalidatesTags: ['Feedbacks'],
    }),
    getFeedback: builder.query<
      {
        is_issues_available: boolean
        is_feedbacks_available: boolean
        is_suggestions_available: boolean
      },
      { email?: string; cpf?: string; application_id: number }
    >({
      query: (params) => ({
        url: `${baseUrlFeedback}/availables`,
        params: { ...params },
      }),
      transformResponse: (
        res: Res<{
          is_issues_available: boolean
          is_feedbacks_available: boolean
          is_suggestions_available: boolean
        }>,
      ) => res.data,
      providesTags: ['Feedbacks'],
    }),
    getAvailableInstitutionalAssessments: builder.query<
      InstitutionalAssessment[],
      FeedbackRequiredFieldParams
    >({
      query: (params) => ({
        url: `${baseUrlFeedback}/institutional-assessments`,
        params: { ...params, type: 'teacher' },
      }),
      providesTags: [{ type: 'InstitutionalAssessments', id: 'LIST' }],
      transformResponse: (res: Res<InstitutionalAssessment[]>) => res.data,
    }),
    getInstitutionalAssessmentDetails: builder.query<
      InstitutionalAssessmentDetails,
      FeedbackRequiredFieldParams & { id: number }
    >({
      query: ({ id, ...params }) => ({
        url: `${baseUrlFeedback}/institutional-assessments/${id}`,
        params: { ...params, type: 'teacher' },
      }),
      providesTags: (_, __, { id }) => [{ type: 'InstitutionalAssessments', id }],
      transformResponse: (res: Res<InstitutionalAssessmentDetails>) => res.data,
    }),
    addInstitutionalAssessmentResponse: builder.mutation<
      void,
      {
        params: AddInstitutionalAssessmentResponseParams
        data:
          | AddInstitutionalAssessmentResponsePayload
          | AddInstitutionalAssessmentResponseClassroomSubjectPayload
      }
    >({
      query: ({ params, data }) => ({
        url: `${baseUrlFeedback}/answerables`,
        method: 'POST',
        params,
        body: data instanceof FormData ? data : removeNullProps({ ...data }),
      }),
      invalidatesTags: ['InstitutionalAssessments'],
    }),
  }),
})

export const {
  useGiveFeedbackMutation,
  useGetFeedbackQuery,
  useLazyGetFeedbackQuery,
  useGetAvailableInstitutionalAssessmentsQuery,
  useGetInstitutionalAssessmentDetailsQuery,
  useAddInstitutionalAssessmentResponseMutation,
} = baseFeedbackApi
